// DB module format
export interface UserGroupsResponse {
  data: UserGroup[];
  success: boolean;
  total: number;
}
export interface UserGroup {
  _id: string;
  name: string;
  type: UserGroupType;
  specifics: {
    company: {
      id: string;
      name: string;
    };
    description: string;
    guid: string;
    users: string[];
  };
}

// enums
export enum UserGroupType {
  CUSTOM = 1,
  ACTIVE_DIRECTORY = 2,
}
